import { Component, OnInit, Input } from '@angular/core';
import * as saveAs from 'file-saver';


@Component({
  selector: 'app-files-viewer',
  templateUrl: './files-viewer.component.html'
})
export class FilesViewerComponent implements OnInit {
  @Input() files: any = [];
  @Input() meetingId!: number;
  @Input() canSaveFile!: boolean;
  docsEditable = false;


  constructor() { }

  ngOnInit() {
  }
  fileType(fileName) {
    const extension = fileName.split('.').pop().toLowerCase();
    switch (extension) {
      case 'pdf':
        return 'pdf';
      case 'jpeg':
      case 'jpg':
        return 'jpg';
      case 'png':
        return 'png';
      case 'doc':
      case 'docx':
      case 'wpd':
      case 'tex':
        return 'doc';
      case 'ppt':
      case 'pptx':
        return 'ppt';
      case 'xlsx':
      case 'xls':
        return 'xls';
      case 'zip':
      case 'rar':
        return 'zip';
      default:
        return false;
    }
  }
  /**
   * format bytes
   * @param bytes (File size in bytes)
   * @param decimals (Decimals point)
   */
  formatBytes(bytes, decimals = 0) {
    if (bytes === 0) {
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals || 2;
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
  }

  download(file: any) {
    saveAs(file.path, file.name);

  }
}
